import { Typography, Form, Input, Button, Spin, message } from 'antd';
import { useMutation } from 'react-query';
import useHttpClient from '../../../shared/sendRequest/useHttpClient';
import EndPoints from '../../../shared/endPoints/EndPoints.json';
import { colors } from '../../../shared/styles/baseStyle';
import AuthLayout from '../../../components/AuthLayout/AuthLayout';
import AuthCard from '../../../components/AuthCard/AuthCard';
import { useAuthFlowContext } from '../../../shared/context/auth-flow-context';
import {
  button,
  buttonItem,
  forgotPasswordButton,
  forgotPasswordRow,
  inputItem
} from './styles';
import { useAuthContext } from '../../../shared/context/auth-context';

const { Text } = Typography;

export default function LoginPassword() {
  const { login } = useAuthContext();
  const [form] = Form.useForm();
  const { sendRequest } = useHttpClient();
  const { policyNumber } = useAuthFlowContext();

  const { mutate, isLoading } = useMutation(sendRequest, {
    onSuccess: data => {
      login(data?.accessToken, false);
    },
    onSettled: () => {
      form.resetFields();
    }
  });

  const { mutate: forgotPassword, isLoading: isForgotPasswordLoading } =
    useMutation(sendRequest, {
      onSuccess: () => {
        message.success(
          'Ακολούθησε τις οδηγίες που θα λάβεις στο email σου για την επαναφορά κωδικού'
        );
      }
    });

  const onFinish = values => {
    mutate({
      endpoint: EndPoints.USER.LOGIN,
      method: 'POST',
      bodyData: {
        username: policyNumber,
        password: values.password
      }
    });
  };

  const handleForgotPassword = () => {
    forgotPassword({
      endpoint: `${EndPoints.USERACCOUNT.FORGOTPASSWORD}?Username=${policyNumber}`,
      method: 'GET'
    });
  };
  return (
    <AuthLayout>
      <Spin spinning={isLoading || isForgotPasswordLoading} size="large">
        <AuthCard
          title="Είσοδος"
          subtitle="Εισήγαγε τον κωδικό σου για να συνδεθείς"
        >
          <Form form={form} onFinish={onFinish} layout="vertical">
            <Form.Item
              label={<Text strong>Κωδικός</Text>}
              name="password"
              rules={[
                {
                  required: true,
                  message: 'Παρακαλώ εισάγετε κωδικό'
                }
              ]}
            >
              <Input.Password size="large" style={inputItem} />
            </Form.Item>
            <div style={forgotPasswordRow}>
              <Button
                type="link"
                onClick={handleForgotPassword}
                style={forgotPasswordButton}
              >
                Ξέχασα τον κωδικό μου
              </Button>
            </div>
            <Form.Item shouldUpdate style={buttonItem}>
              {() => {
                const isDisabled = !form.getFieldValue('password');
                return (
                  <Button
                    htmlType="submit"
                    block
                    size="large"
                    disabled={isDisabled}
                    style={{
                      ...button,
                      background: isDisabled
                        ? colors.disabledGrey
                        : colors.anytimeBlue
                    }}
                  >
                    Σύνδεση
                  </Button>
                );
              }}
            </Form.Item>
          </Form>
        </AuthCard>
      </Spin>
    </AuthLayout>
  );
}
